import { useState } from "react"
import { useAuth } from "../../hooks/useAuth"
import axiosInstance from "../../services/axios-client"

const useLogin = () => {
    const [payload, setPayload] = useState({})
    const [loadingPagestate, setLoadingPagestate] = useState(false)
    const [passwordResetMessage, setPasswordResetMessage] = useState('')
    const {
        login,
        loginError,
        setLoginError
    } = useAuth()

    const onChangeHandler = (e) => {
        setLoginError(false)
        setPasswordResetMessage('')
        setPayload({ ...payload, [e.target.name]: e.target.value })
    }

    const loginHandler = async (e) => {
        e.preventDefault()
        try {
            setLoadingPagestate(true)
            setLoginError(false)
            let data = { ...payload, Email: payload.Email.toLowerCase() }
            let res = await axiosInstance.post("/login", data)
            if (res.status === 200) {
                login(res.data.data.AccessToken, JSON.stringify({
                    ...res.data.data.TokenModel,
                    SwitchUser: {
                        Email: res.data.data.TokenModel.Email,
                        ID: res.data.data.TokenModel.ID,
                        Name: res.data.data.TokenModel.Name,
                        Role: res.data.data.TokenModel.Role,
                        Username: res.data.data.TokenModel.Username
                    }
                }))
            } else {
                // insert notif
            }
            setLoadingPagestate(false)
        } catch (error) {
            setLoadingPagestate(false)
            // Check if it's a 307 password reset requirement
            if (error?.response?.status === 307 && error?.response?.data?.data?.requirePasswordReset) {
                const message = error.response.data.data.message || 'Password reset required. Please change your password to continue.'
                const redirectUrl = error.response.data.data.redirectUrl
                // Store message in sessionStorage to show on reset password page
                sessionStorage.setItem('passwordResetMessage', message)
                // Navigate to the redirect URL directly
                window.location.href = redirectUrl
                return
            }
            setLoginError(true)
            // Optionally log error details for debugging
            console.error('Login error:', error?.response?.data?.status?.description || error.message || error)
        }
    }

    const loginGoogleHandler = async (code) => {
        const options = {
            code: code,
        };

        const qs = new URLSearchParams(options);
        setLoginError(false)
        try {
            setLoadingPagestate(true)
            const res = await axiosInstance.get(`/sessions/oauth?${qs.toString()}`)

            if (res.status === 200) {
                login(res.data.data.AccessToken, JSON.stringify({
                    ...res.data.data.TokenModel,
                    SwitchUser: {
                        Email: res.data.data.TokenModel.Email,
                        ID: res.data.data.TokenModel.ID,
                        Name: res.data.data.TokenModel.Name,
                        Role: res.data.data.TokenModel.Role,
                        Username: res.data.data.TokenModel.Username
                    }
                })
                )
            }
            setLoadingPagestate(false)
        } catch (error) {
            setLoadingPagestate(false)
            // Check if it's a 307 password reset requirement
            if (error?.response?.status === 307 && error?.response?.data?.data?.requirePasswordReset) {
                const message = error.response.data.data.message || 'Password reset required. Please change your password to continue.'
                const redirectUrl = error.response.data.data.redirectUrl
                // Store message in sessionStorage to show on reset password page
                sessionStorage.setItem('passwordResetMessage', message)
                // Navigate to the redirect URL directly
                window.location.href = redirectUrl
                return
            }
            setLoginError(true)
            // Optionally log error details for debugging
            console.error('Google login error:', error?.response?.data?.status?.description || error.message || error)
        }
    }
    return {
        payload,
        loginHandler,
        loginGoogleHandler,
        onChangeHandler,
        loginError,
        setLoginError,
        loadingPagestate,
        setLoadingPagestate,
        passwordResetMessage,
        setPasswordResetMessage
    }
}

export default useLogin